import type { ApplicationFormStatus } from '../../api/applicationForm';

/** How the application form's status reads, for staff and students alike. */
export const APPLICATION_FORM_STATUS_LABEL: Record<ApplicationFormStatus, string> = {
  NOT_SENT: 'Not Sent',
  INVITATION_SENT: 'Invitation Sent',
  IN_PROGRESS: 'In Progress',
  SUBMITTED: 'Submitted for Review',
  REJECTED: 'Rejected – Changes Required',
  RESUBMITTED: 'Resubmitted',
  APPROVED: 'Approved',
};
